<template>
  <CSpin v-if="apiState.isFetchingFavorites" class="flex h-full" />
  <div v-else class="w-full h-full" :class="{ 'pr-3': isContentPanelOpen }">
    <CList
      class="favorites-table rounded-2 flex bg-base"
      :data="displayedFavorites"
      :maxRowHeight="150"
      :selectedIds="selectedItemIds"
      @item:click="openItem"
    >
      <template #item="{ item, isSelected, isDraggedOver, isContextMenuOpen }">
        <BrowserListItem
          do-not-show-folder-details
          :filters="computed(() => ({}) as Record<string, any>)"
          :highlight-text="apiState.searchQuery"
          :is-context-menu-open="isContextMenuOpen"
          :is-dragged-over="isDraggedOver"
          :is-selected="isSelected"
          :item="item"
          :style="{ opacity: item.opacity || 1 }"
        >
          <template #actions>
            <FileDetailsPanelButton :item="getTypedItem(item)" />
            <FavoriteButton :item="getTypedItem(item)" />
          </template>
        </BrowserListItem>
      </template>
    </CList>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import BrowserListItem from '@browser/components/Content/Common/BrowserListItem.vue'
import CList from '@lib/components/CList/CList.vue'
import CSpin from '@lib/components/CSpin/CSpin.vue'
import FavoriteButton from '@browser/components/ContextMenu/FavoriteButton.vue'
import FileDetailsPanelButton from '@browser/components/ContextMenu/FileDetailsPanelButton.vue'

import useApiStore from '@browser/stores/api'
import useAppStore from '@browser/stores/app'

import { openItem } from '@browser/util/file'

import type { ViewCompactFolder } from '@lib/types/files'

const { state: apiState } = useApiStore()
const { selectedItemIds, isContentPanelOpen, displayedFavorites } = useAppStore()

const getTypedItem = (item: any) => item as ViewCompactFolder
</script>
